export const home = {
  'Made for': 'Hecho para',
};
